export const DEFAULT_PRINT_ASSET_TIMEOUT_MS = 30000

const waitForImage = image => new Promise(resolve => {
  let settled = false

  const finish = failed => {
    if (settled) return
    settled = true
    resolve({ failed })
  }

  image.addEventListener('load', () => finish(false), { once: true })
  image.addEventListener('error', () => finish(true), { once: true })

  // Cached images can finish between innerHTML assignment and listener setup.
  // Checking after the listeners are attached closes both sides of that race.
  if (image.complete) finish(image.naturalWidth === 0)
})

const settlePromise = promise => Promise.resolve(promise)
  .then(() => ({ failed: false }))
  .catch(() => ({ failed: true }))

export const waitForPrintAssets = (
  images,
  qrCodePromises,
  timeoutMs = DEFAULT_PRINT_ASSET_TIMEOUT_MS,
) => {
  const pendingAssets = [
    ...Array.from(images, waitForImage),
    ...Array.from(qrCodePromises, settlePromise),
  ]
  let timeoutId

  const allAssets = Promise.all(pendingAssets).then(results => ({
    timedOut: false,
    failedAssetCount: results.filter(result => result.failed).length,
  }))
  const timeout = new Promise(resolve => {
    timeoutId = setTimeout(() => resolve({
      timedOut: true,
      failedAssetCount: 0,
    }), timeoutMs)
  })

  return Promise.race([allAssets, timeout]).then(result => {
    clearTimeout(timeoutId)
    return result
  })
}
